import { useCallback } from "react";
import styles from "./styles.module.css";
import { FileIcon } from "../../../icons/FileIcon";

interface Props {
  children?: React.ReactNode;
  dataUrl?: string;
  dataFilename?: string;
  onFileClick?: (url: string, filename: string) => void;
}

export const MessageFileTag = ({
  children,
  dataUrl,
  dataFilename,
  onFileClick,
}: Props) => {
  const handleClick = useCallback(() => {
    if (dataUrl && dataFilename && onFileClick) {
      onFileClick(dataUrl, dataFilename);
    }
  }, [dataUrl, dataFilename, onFileClick]);

  return (
    <span className={styles["message-file-tag"]} onClick={handleClick}>
      <FileIcon className={styles["icon"]} />
      {children}
    </span>
  );
};
